'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paths = require('./paths');

var _middleware = require('../../middleware');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (fid, personId) {
  return function (dispatch, getState) {
    var participant = getState().getIn(['persons', 'one', personId]);

    if (participant && participant.num) return Promise.resolve(participant);

    return dispatch(_defineProperty({
      fid: fid,
      personId: personId

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.feisParticipantByDancerIdUrl)(fid, personId)
      },
      types: ['GET_FEIS_PARTICIPANT_START', 'GET_FEIS_PARTICIPANT', 'GET_FEIS_PARTICIPANT_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/person/getFeisParticipantByDancerId.js
// module id = 656
// module chunks = 0